export default __webpack_public_path__ + "static/media/05MAR.c1a22140.jpg";